export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_12.87c1ce48.jpg";